<template lang="pug">
  .container-outlay-coupon.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 现金券详情
    c-box
      .point-outer-container
        .point-container
          .point-title 可用余额
          .point-amount
            template(v-if="typeof(couponDetail.present_balance) === 'number'") {{ couponDetail.present_balance | toYuan }}
            template(v-else) -
        .point-container
          .point-title 券包数量
          .point-amount
            template(v-if="typeof(couponDetail.package_quantity) === 'number'") {{ couponDetail.package_quantity }}
            template(v-else) -
        .point-container
          .point-title 券包总额
          .point-amount
            template(v-if="typeof(couponDetail.package_amount) === 'number'") {{ couponDetail.package_amount | toYuan }}
            template(v-else) -
        .point-container
          .point-title 可用现金券总额
          .point-amount
            template(v-if="typeof(couponDetail.amount) === 'number'") {{ couponDetail.amount | toYuan }}
            template(v-else) -
    c-box
      el-form(:model="$data", label-position="right", label-width="100px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="日期")
              el-date-picker(v-model="date", type="daterange", placeholder="选择日期范围")
            el-form-item(label="状态")
              el-select(v-model="filters.status")
                el-option(:value="null", label="全部")
                el-option(v-for="n in 4", :key="n", :value="n", :label="n | status")
            el-form-item(label="")
              el-button(@click="setFilter", type="primary") 搜索
              el-button(@click="timeReset") 重置时间
              el-button(@click="clearFilter", v-show="hasFilter") 清除
          el-col(:span="12")
            el-form-item(label="券包 ID")
              el-input(v-model="filters.package_id")
            el-form-item(label="创建者")
              el-select(v-model="filters.app_id")
                el-option(:value="null", label="全部")
                el-option(v-for="a in appList", :key="a.app_id", :value="a.app_id", :label="a.name")
            el-form-item(label="")
              el-button(@click="showExportExcel", type="primary") 导出现金券列表
      el-table(:data="list", fit, v-loading="listLoading")
        el-table-column(property="market_package.package_id", label="券包 ID", min-width="175", show-tooltip-when-overflow)
        el-table-column(property="market_package.title", label="名称", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="market_package.app_name", label="创建者", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="market_package.create_time", label="创建时间", min-width="175", show-tooltip-when-overflow)
        el-table-column(label="面额", min-width="75", show-tooltip-when-overflow, v-slot="{ row }") {{ row.market_package.reduce_cost | toYuan }}
        el-table-column(property="market_package.total_quantity", label="现金券总数", min-width="100", show-tooltip-when-overflow)
        el-table-column(property="market_package.end_time", label="有效期", min-width="175", show-tooltip-when-overflow)
        el-table-column(label="状态", min-width="75", show-tooltip-when-overflow, v-slot="{ row }") {{ row.market_package.status | status }}
        el-table-column(label="操作", min-width="100", align="right", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="showDetail(row.market_package.package_id)") 详情
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="导出现金券列表", :visible.sync="exportExcel.show")
      el-form(:model="exportExcel", label-position="right", label-width="100px")
        el-form-item(label="") 如果只需导出一天的列表，导出日期范围首末设置为同一天即可。
        el-form-item(label="导出日期", required)
          el-date-picker(v-model="exportExcel.date", type="daterange", placeholder="选择日期范围")
        el-form-item(label="券包 ID")
          el-input(v-model="exportExcel.package_id")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="toExportExcel()") 导出
        el-button(@click="hideExportExcel()") 取消
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   10,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      filters: {
        package_id:   null,
        status:       null,
        app_id:       null,
      },
      date:       [],
      hasFilter:  false,

      couponDetail: {
        amount:           null,
        package_quantity: null,
        present_balance:  null,
      },

      appList:  [],

      exportExcel: {
        show:       false,
        date:       [],
        package_id: null,
      },
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    },
  },
  filters: {
    status (source) {
      switch (source) {
        case  1:  return '待审核';
        case  2:  return '审核失败';
        case  3:  return '已审核';
        case  4:  return '已删除';
        case  5:  return '已过期';
        case  6:  return '已返还';
        default:  return source;
      }
    },
  },
  methods: {
    showDetail (package_id) {
      const date = this.date.length === 2
        ? [this.$dateFormatter(this.date[0]), this.$dateFormatter(this.date[1])]
        : [];

      localStorage.setItem('outlay_coupon', JSON.stringify(Object.assign({}, {
        filters:    this.filters,
        date,
        page:       this.page,
        size:       this.size,
      })));

      this.$router.push(`${this.detailURL}/coupon/${package_id}`);
    },

    showExportExcel () {
      this.exportExcel = {
        show:       true,
        date:       [],
        package_id: null,
      };
    },
    hideExportExcel () {
      this.exportExcel = {
        show:       false,
        date:       [],
        package_id: null,
      };
    },
    toExportSingleDay (_date) {
      const date = _date.split(' ')[0];
      this.exportExcel.date = [date, date];
      this.toExportExcel();
    },
    toExportExcel () {
      if (!this.exportExcel || this.exportExcel.date.length !== 2) {
        this.$message({
          type:     'warning',
          message:  `请输入报表导出日期范围`,
        });
        return;
      }
      const date = [this.$dateFormatter(this.exportExcel.date[0]), this.$dateFormatter(this.exportExcel.date[1])];

      const baseURL = '/mch_web/v1/mch_payment/export_coupon_package_list';
      const url = `${baseURL}?outlay_account_id=${this.outlay_account_id}&` +
                  `start_date=${date[0]}&end_date=${date[1]}&package_id=${this.exportExcel.package_id || ''}`;

      console.log(url);
      window.open(url);

      this.hideExportExcel();
    },

    // getCoinDetail () {
    //   return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COUPON_DETAIL', this.outlay_account_id).then((data) => {
    //     this.couponDetail = data;
    //     return data;
    //   }).catch(({ code, msg }) => {
    //     this.$message({
    //       type:     'error',
    //       message:  `获取积力宝详情失败。${code}：${msg}`,
    //     });
    //   });
    // },

    getAppList () {
      const account_id = this.outlay_account_id;
      return this.$store.dispatch('GET_AUTH_APP_LIST', account_id).then(({ app_list }) => {
        this.appList = app_list;
        return app_list;
      });
    },

    timeReset () {
      this.date = [];
      this.refresh();
    },
    setFilter () {
      if (this.filters.package_id || this.filters.status || this.filters.app_id ||
        (Array.isArray(this.date) && this.date.length === 2)) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter () {
      this.filters = {
        package_id:   null,
        status:       null,
        app_id:       null,
      };

      this.hasFilter = false;
      this.timeReset();
      this.refresh();
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters, {
        outlay_account_id:  this.outlay_account_id,
        start_date:         (Array.isArray(this.date) && typeof this.date[0] !== 'undefined') ? this.$dateFormatter(this.date[0]) : null,
        end_date:           (Array.isArray(this.date) && typeof this.date[1] !== 'undefined') ? this.$dateFormatter(this.date[1]) : null,
      });
      this.$store.dispatch('GET_OUTLAY_ACCOUNT_COUPON_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    // this.getCoinDetail();
    this.getAppList();

    const filters = localStorage.getItem('outlay_coupon');

    if (filters) {
      localStorage.removeItem('outlay_coupon');
      const f = JSON.parse(filters);
      this.filters = f.filters;
      this.date = f.date;
      this.size = f.size;

      this.setFilter();
    } else {
      this.getList(1);
    }
  },
};
</script>
